import * as React from 'react';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { useParams } from 'react-router';
import classnames from 'classnames';

import { Button, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { getCurrentSkills, getTodaysTasks } from '../../common/utils/programUtils';
import { green3 } from '../../app/style/theme';
import urls from '../../app/urls';
import { InfoBox, SkillLink, TaskLink } from '../../common/components';


const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderBottom: theme.borders.normal,
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(10),

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            paddingBottom: theme.spacing(1),
        },
    },
    infoBox: {
        flexBasis: `calc(100% / 2 - ${theme.spacing(2)}px)`,
        overflow: 'hidden',
        margin: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            flexBasis: `calc(100% - ${theme.spacing(1)}px)`,
            margin: theme.spacing(0, 0, 1, 0),
        },
    },
    endButton: {
        alignSelf: 'center',
        width: 300,
    },
}));

const Home = () => {
    const { code } = useParams();
    const programData = useSelector(state => state.studentCodeStore.details && state.studentCodeStore.details[code]);

    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));

    if (!programData) {
        return null;
    }

    const currentSkills = getCurrentSkills(programData);
    const todaysTasks = getTodaysTasks(programData);

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                {currentSkills?.length ? (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.skill')}
                        color={green3}
                    >
                        {currentSkills.map(skill => <SkillLink key={skill.module.name} skill={skill} studentCode={code} />)}
                    </InfoBox>
                ) : (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.skill')}
                        primary={translate('dashboard.noCurrentSkill')}
                        color={green3}
                    />
                )}
                {todaysTasks && todaysTasks.length > 0 ? (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.todaysTasks')}
                        color={green3}
                    >
                        {todaysTasks.map(task => (
                            <TaskLink
                                task={task}
                                skillName={task.skillName}
                                key={task.id}
                                to={`${urls.studentCode.home}/${code}/${urls.studentCode.parts.skill}/${task.skillId}/${urls.studentCode.parts.task}/${task.id}`}
                            />
                        ))}
                    </InfoBox>
                ) : (
                    <InfoBox
                        className={classnames(classes.infoBox, classes.hideOnSmall)}
                        heading={translate('dashboard.todaysTask')}
                        primary={translate('dashboard.noTasksToday')}
                        color={green3}
                    />
                )}
            </div>
            <Button className={classes.endButton} variant="contained" color="secondary" component={Link} to={urls.home}>
                {translate('studentLogin.end')}
            </Button>

        </div>
    );
};

export default Home;
